import { useContext, useEffect } from 'react';

import { AuthContext } from 'context/AuthContext';
import { AuthService } from 'services/main';
import { getLocalAuthStorage } from 'utils/localStorage';
import { FiltersContext } from 'context/GlobalFiltersContext';
import { skeleton as initialHeadersFiltersState } from 'context/GlobalFiltersContext/initialState';
import { useCookies } from 'react-cookie';
import { removeHeaderFilterCookies } from 'utils/cookies';
import { URLS } from 'constants/urls';

const Logout = () => {
  const { setFiltersContext } = useContext(FiltersContext);
  const { setAuthContext } = useContext(AuthContext);
  let { token } = getLocalAuthStorage();
  const removeCookie = useCookies()[2];
  const cookie = useCookies()[0];
  useEffect(() => {
    const logout = async () => {
      await AuthService.logout({ token });
    };
    if (cookie?.authToken) {
      logout()
        .then(() => {
          localStorage.setItem('socket', null);
          removeHeaderFilterCookies(removeCookie);
          setFiltersContext(initialHeadersFiltersState);
          sessionStorage.removeItem('adsPopupOpenedAfterLogin');

          setAuthContext({
            statusCode: false,
            isAuthenticated: false,
            token: null,
            refreshToken: null,
            expiresIn: null,
            user: {
              name: null,
            },
          });
          if (process.env.REACT_APP_MODE !== 'local') {
            window.location.href = `${process.env.REACT_APP_LEGADO}/security/signout.aspx`;
          } else {
            const lastLoginRoute = cookie?.lastLoginRoute;
            removeCookie('lastLoginRoute', { path: '/', domain: URLS.cookieDomain });
            window.location.replace(lastLoginRoute || '/login');
          }
        })
        .catch(error => {
          console.error({ error });
          window.localStorage.clear();
        });
    } else {
      removeHeaderFilterCookies(removeCookie);
      setFiltersContext(initialHeadersFiltersState);
      sessionStorage.removeItem('adsPopupOpenedAfterLogin');

      setAuthContext({
        statusCode: false,
        isAuthenticated: false,
        token: null,
        refreshToken: null,
        expiresIn: null,
        user: {
          name: null,
        },
      });
      removeCookie('qrcodeFilters', { path: '/', domain: URLS.cookieDomain });
      removeCookie('openNewChamado', { path: '/', domain: URLS.cookieDomain });
      removeCookie('chamadoWoba', { path: '/', domain: URLS.cookieDomain });
      removeCookie('chamadosAccess', { path: '/', domain: URLS.cookieDomain });
      removeCookie('wobaRoute', { path: '/', domain: URLS.cookieDomain });

      window.localStorage.clear();
      const lastLoginRoute = cookie?.lastLoginRoute;
      removeCookie('lastLoginRoute', { path: '/', domain: URLS.cookieDomain });
      window.location.replace(lastLoginRoute || '/login');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};

export { Logout };
